
<template>
    <div class="login-div">
	   <!-- echarts -->

      <div class="echartsCon flexC">
          <div class="titleCon flexCC flexD">
              <div  class="titleConItem flexBC">
                   <div class="desc">{{$t('deviceManage.topTotal1')}}</div>
                   <div class="num">
                       <span>{{indexData.total}}</span>
                   </div>
              </div>
              <div  class="titleConItem flexBC">
                   <div class="desc">{{$t('deviceManage.topTotal2')}}</div>
                   <div class="num">
                       <span>{{indexData.signIn30}}</span>
                   </div>
              </div>
              <div  class="titleConItem flexBC">
                   <div class="desc">{{$t('deviceManage.topTotal3')}}</div>
                   <div class="num">
                       <span>{{indexData.online}}</span>
                   </div>
              </div>
              
          </div>
          <div id="main"></div>
      </div>

      <!-- 搜索 -->
       <div class="search-div flexC">
            
             <div class="search-div-item flexC">
               <div class="labelText">{{$t("deviceManage.serialNumber")}}</div>
               <Input class="input-div" :placeholder='$t("inputPlaceholder")' clearable v-model="searchObj.serialNumber" ></Input>
            </div>

             <div class="search-div-item flexC">
               <div class="labelText">{{$t("deviceManage.macAddress")}}</div>
               <Input class="input-div" :placeholder='$t("inputPlaceholder")' clearable v-model="searchObj.macAddress" ></Input>
            </div>

             <div class="search-div-item flexC">
               <div class="labelText">{{$t("deviceManage.titleName.User_account")}}</div>
               <Input class="input-div" :placeholder='$t("inputPlaceholder")' clearable v-model="searchObj.userAccount" ></Input>
            </div>

             <div class="search-div-item flexC">
               <div class="labelText">{{$t("deviceManage.titleName.Type")}}</div>
                <Select  :placeholder='$t("selectPlaceholder")' filterable  clearable class="input-div" v-model="searchObj.productTypeId" >
                    <Option v-for="(item, index) in productsManageList" :value="item.id" :key="index">{{item.productType}}</Option>
                </Select>
                 <!-- <Input class="input-div" :placeholder='$t("inputPlaceholder")' clearable v-model="searchObj.productTypeId" ></Input> -->
            </div>

             <div class="search-div-item flexC">
               <div class="labelText">{{$t("deviceManage.status")}}</div>
                <Select  :placeholder='$t("selectPlaceholder")'  clearable class="input-div" v-model="searchObj.status" >
                    <Option v-for="(item, index) in searchObjArr.status" :value="item.id" :key="index">{{item['val']}}</Option>
                </Select>
            </div>

             <div class="search-div-item flexC">
               <div class="labelText">{{$t("deviceManage.whetherOnline")}}</div>
                <Select  :placeholder='$t("selectPlaceholder")'  clearable class="input-div" v-model="searchObj.whetherOnline" >
                    <Option v-for="(item, index) in searchObjArr.onlineType" :value="item.id" :key="index">{{item['val']}}</Option>
                </Select>
            </div>

             <div class="search-div-item">
                <Button type="info" @click="searchItem"  icon="ios-search" style="marginTop:5px;height:44px;line-height:44px;width:96px;border-radius: 10px;">{{$t('search')}}</Button>
             </div>
         
        </div>

        <!-- 表格 -->
        <div class="tableCon">
            <div class="top flexBC">
                <div>
                     <Button type="primary" :disabled="buttonList.editDisabled" @click="moveData(1)" style="margin-right:8px;">{{$t("deviceManage.Move")}}</Button>
                     <Button type="info" :disabled="buttonList.addDisabled" @click="addData(1)" style="margin-right:8px; border-radius: 6px;">{{$t("deviceManage.ManageGroup")}}</Button>
                </div>
                <div class="flexC">
                    <div style="position:relative;z-index:50">
                       <Icon type="ios-options" @click="showCheckboxSelect =!showCheckboxSelect" size='24' color='#4ABAF0' class="optionsIcon" :title='$t("deviceManage.filter")' />
                       <div class="CheckboxSelect" v-if='showCheckboxSelect'>
                           <tableColumnFilter  :filterFiled='titleName1' :defaultCheck='defaultCheckList' @filter-field-change="refreshTable"></tableColumnFilter>
                       </div>
                    </div>
                    <Icon type="ios-download" size='24' @click="exportData" color='#4ABAF0' class="optionsIcon"  :title='$t("deviceManage.export")' />
                    <Icon type="ios-print" size='24'  @click="print('div_print')" color='#4ABAF0' class="optionsIcon"  :title='$t("deviceManage.print")' />
                </div>
               
            </div>

            <Table  :columns="titleName" :data="tableList.tableData" @on-sort-change="sortCustom" ref="table" @on-selection-change="selectChange" :loading='loading'></Table>
           
           <div id='div_print' v-show="0">
              <Table  :columns="titleName1" :data="tableList.tableData" @on-sort-change="sortCustom" ref="table" @on-selection-change="selectChange" :loading='loading'></Table>
           </div>



           <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :page-size-opts="[10,20,30,50,100]" placement="top" class="pages"/>
        </div>

         <!-- 移动  模态框组件 -->
           <ModelBox :showModel.sync="addBox.showModel" :fn="addBox.callbackFn" :type="type" :editFormData="addBox.editFormDataArr"></ModelBox>

         <!-- 移动经销商 -->
           <DealerModelBox :showModel.sync="moveDealerBox.showModel" :fn="moveDealerBox.callbackFn"  :editFormData="moveDealerBox.editFormData"></DealerModelBox>

          <!-- 管理组织 -->
          <manageModelBox :showModel.sync="detailBox.showModel" :fn="detailBox.callbackFn"  :editFormData="detailBox.editFormData"></manageModelBox>
          
          <!-- 解绑 -->
          <DeleteDialog ref="deleteChild" @ievent = "ievent"  :title='$t("deviceManage.Unbundling")' :cont='$t("deviceManage.UnbundlingCont")'></DeleteDialog>
         
    </div >
    
</template>

<script>
import common from "@/common/common.js";
import moment from "moment";
import ModelBox from './component/addModel';
import DealerModelBox from './component/dealerMoveModel';
import manageModelBox from './component/manageModel.vue';
import DeleteDialog from '../common/deleteModel.vue'; // 引入删除弹框组件
import tableColumnFilter from './component/tableColumnFilter.vue'; 
import expandRow from './component/table-ad-expand.vue';
import timerJs from "@/common/time.js"
import { mapState } from 'vuex'

export default {
    name: "deviceManage",
    components: {
       ModelBox,
       manageModelBox,
       DeleteDialog,
       DealerModelBox,
       tableColumnFilter,
       expandRow,
    },
    data() {
        return {
        loading: true,
        type:1,//弹框打开类型 1添加 2编辑
        tableList:{//表格组
            hasSelectData:{},//已选中的行的数据
            hasSelectDataArr:[],//已选中的行的数据数组
            tableData: []//表格数据
        },
        showCheckboxSelect:false,
        buttonList:{//按钮组
            addDisabled:false,//添加按钮是否禁用
            editDisabled:true,//编辑按钮是否禁用
            delDisabled:true,//删除按钮是否禁用
        },
        addBox:{//规格弹框组-移动
            showModel:false,//弹框开关
            callbackFn:()=>{}, //弹框的回调函数
            editFormData:{},//编辑时传入的现有数据
            editFormDataArr:[]
        },
        moveDealerBox:{//规格弹框组-移动
            showModel:false,//弹框开关
            callbackFn:()=>{}, //弹框的回调函数
            editFormData:{},//编辑时传入的现有数据
        },
        detailBox:{//规格弹框组-详情
            showModel:false,//弹框开关
            callbackFn:()=>{}, //弹框的回调函数
            editFormData:{},//编辑时传入的现有数据
        },
        buttonProps: {
              type: 'default',
              size: 'small',
          },
        page:{//分页排序
            total:0,//总条数
            pageSize:10,//每页条数
            current:1,//当前页
            key:'created_at',
            order:'desc'
        },
        searchObj:{
            serialNumber: '',
            macAddress: '',
            productTypeId: '',
            status: '',
            whetherOnline: '',
            userAccount:''
        },
        indexData:{
            total:'',
            signIn30:'',
            online:''
        },
        chartData:{//图表数据
            dataList:[],
            monthList:[]
        },
        productsManageList:[],
        defaultCheckList:[],
        selectedFieldList:[],
        titleName1:[
            { // 伸缩框
                type: 'expand',
                'title-zh-CN':'用户信息',
                'title-en-US':'User information',
                 width: 180,
                render:(h, params) => {
                    console.log('params',params)
                    return h(expandRow, {
                        props: {
                            ref:'son',
                            params: params.row,
                        }
                    })
                }
            },
            {
                title: '',
                'title-zh-CN':'序列号',
                'title-en-US':'Serial number',
                key: 'serialNumber',
                align:'center',
                customOrder:1,
                minWidth: 180
            },
             {
                title: '',
                'title-zh-CN':'MAC地址',
                'title-en-US':'MAC',
                key: 'macAddress',
                align:'center',
                customOrder:2,
                minWidth: 160
            },
             {
                title: '',
                'title-zh-CN':'产品型号',
                'title-en-US':'Type',
                key: 'productType',
                align:'center',
                customOrder:3,
                minWidth: 160
            },
             {
                title: '',
                'title-zh-CN':'工作频率',
                'title-en-US':'Operating frequency',
                key: 'frequency',
                align:'center',
                customOrder:4,
                minWidth: 180
            },
            {
                title: '',
                'title-zh-CN':'设备组',
                'title-en-US':'Device group',
                key: 'deviceGroupName',
                align:'center',
                customOrder:5,
                minWidth: 150
            },
             {
                title: '',
                'title-zh-CN':'产品状态',
                'title-en-US':'Activate',
                key: 'status',
                align:'center',
                customOrder:6,
                minWidth: 120,
                render:(h, params)=>{
                     let obj = {'1':'Free','2':'Activate','3':'Return'}
                     let flag = params.row.status

                     let stext = obj.hasOwnProperty(flag)?this.$t('selectList.deviceStatus.'+obj[flag]):flag

                     return h('div',stext || '')
                }
            },
             {
                title: '',
                'title-zh-CN':'是否在线',
                'title-en-US':'Online / Offline',
                key: 'whetherOnline',
                minWidth: 140,
                align:'center',
                customOrder:7,
                render:(h, params)=>{
                    let obj = {'1':'Online','2':'Online','3':'Outline','0':'Outline'}
                     let flag = params.row.whetherOnline

                     let stext = obj.hasOwnProperty(flag)?this.$t('selectList.onlineType.'+obj[flag]):flag

                     return h('div',stext || '')
                }
            },
            {
                title: '',
                'title-zh-CN':'激活时间',
                'title-en-US':'Activate time',
                key: 'activateTime',
                minWidth: 180,
                align:'center',
                customOrder:8,
                render:(h, params)=>{
                    let stext = params.row.activateTime?moment(params.row.activateTime*1).format('YYYY-MM-DD HH:mm:ss'):''
                     return h('div',stext || '')
                }
            },
            {
                title: '',
                'title-zh-CN':'经销商',
                'title-en-US':'Dealer id',
                key: 'usedDealerId',
                minWidth: 120,
                align:'center'
            },
            {
                title: '',
                'title-zh-CN':'用户账号',
                'title-en-US':'User account',
                key: 'userAccount',
                align:'center',
                customOrder:9,
                minWidth: 150
            },
            {
                title: '',
                'title-zh-CN':'当前地址',
                'title-en-US':'Location',
                key: 'deviceLocation',
                align:'center',
                customOrder:10,
                minWidth: 180
            },
            {
                title: '',
                'title-zh-CN':'同步时间',
                'title-en-US':'Sync time',
                key: 'syncTime',
                minWidth: 180,
                align:'center',
                customOrder:11,
                render:(h, params)=>{
                    let stext = params.row.syncTime?moment(params.row.syncTime*1).format('YYYY-MM-DD HH:mm:ss'):''
                     return h('div',stext || '')
                }
            },
            {
                title: '',
                'title-zh-CN':'最后更新',
                'title-en-US':'Last update',
                key: 'updateTime',
                minWidth: 180,
                align:'center',
                customOrder:12,
                render:(h, params)=>{
                    let stext = params.row.updateTime?moment(params.row.updateTime*1).format('YYYY-MM-DD HH:mm:ss'):''
                     return h('div',stext || '')
                }
            },
        ],
        titleName: [],
        selec : {  type: 'selection',  width: 60, align: 'center',fixed:'left'},
        
        }
    },
    computed:{
      ...mapState(['local','selectId']),
       roleType(){
	    	 let res = '2'
	    	 if(this.$store.state.uInfo && this.$store.state.uInfo.roleType){
	    		 res = this.$store.state.uInfo.roleType
	    	 }
	    	 return res
	   },
       searchObjArr(){
           return {
               status:[
                  {id: 1,val:this.$t('selectList.deviceStatus.Free')},
                  {id: 2,val:this.$t('selectList.deviceStatus.Activate')},
                  {id: 3,val:this.$t('selectList.deviceStatus.Return')},
               ],
               
               onlineType:[
                  {id: 1,val:this.$t('selectList.onlineType.Online')},
                  {id: 0,val:this.$t('selectList.onlineType.Outline')},
               ]
          }
       },
       Operation(){
           return {
		    	title: '',
                'title-zh-CN':'操作',
                'title-en-US':'Operation',
                // fixed:'right',
		    	minWidth:this.roleType== 1?160:120,
                key: "Operation",
		    	render: (h, params) => {
                    let that = this
                    return h('div',{
                             style:{
                                display: "flex",
                                justifyContent:'center'
                             }
                         },
                         [
                              h('Button', {
		    	                  props: {
                                      type: "default",
                                      size: 'small'
                                  },
                                  style:{
                                      display:this.roleType==1? 'block':'none',
                                      'margin-right':'8px'
                                  },
		    	                  on: {
		    	                      click: () => { 
                                           this.moveDealer(params.row)
                                       }
		    	                  }
		    	              },that.$t("deviceManage.Move")),
                                
                              h('Button', {
		    	                  props: {
                                      type: "error",
                                      size: 'small'
                                  },
                                  attrs:{
                                      disabled:params.row.status!=2
                                  },
		    	                  on: {
		    	                      click: () => { 
                                          if(params.row.status==2){
                                              this.todelData(params.row)
                                          }
                                       }
		    	                  }
		    	              },that.$t("deviceManage.Unbundling"))
                        ]
                    
                    )
                   
		    	}
		    }
       }
       
    },
    created() {
      this.setTitle()
      this.titleName = [this.selec,...this.titleName1,this.Operation]
      this.titleName1.map(item=>{
           this.defaultCheckList.push(item.title)
      })
      this.getData();
      this.getTopData()
      this.getchartData();
      this.getSelect()
    },
    watch: {
      local(newval,oldval){
        this.setTitle()
      }
    },
    mounted(){
      this.initEcharts()
    },
    methods: { 
        refreshTable(selectedField) { //过滤字段，刷新表格显示内容
            let showField = [];
            this.selectedFieldList = selectedField = Array.from(selectedField)
            for(let i=0;i<this.titleName1.length;i++){
                for(let j=0;j<selectedField.length;j++){
                    if(this.titleName1[i].title==selectedField[j]){
                        showField.push(this.titleName1[i])
                    }
                }
            }

            if (showField.length) {
                showField.sort((a, b) => {
                  return a.customOrder > b.customOrder
                })
            }
            
            //序号和操作固定
            this.titleName = [this.selec,...showField,this.Operation];
        },
        exportData() { //导出
 

               let arr = [];
               let dataList = JSON.parse(JSON.stringify(this.tableList.tableData)) 
               arr =  this.$refs.table.exportCsv({
                    filename: 'Custom data',
                    columns: this.titleName.filter((col, index) => {
                        return index>0 && index<this.titleName.length-1 && col.type!="expand"
                    }),
                    
                    data: dataList.filter((item, index) =>{ 
                        if(this.searchObj.serialNumber){
                            item.serialNumber == this.searchObj.serialNumber
                        }else if(this.searchObj.macAddress){
                            item.macAddress == this.searchObj.macAddress
                        }else if(this.searchObj.productTypeId){
                            item.productTypeId == this.searchObj.productTypeId
                        }else if(this.searchObj.status){
                            item.status == this.searchObj.status
                        }else if(this.searchObj.userAccount){
                            item.userAccount == this.searchObj.userAccount
                        }else if(this.searchObj.whetherOnline ===1 || this.searchObj.whetherOnline===0){
                            item.whetherOnline == this.searchObj.whetherOnline
                        }


                      let obj1 = {'1':'Online','2':'Online','3':'Outline','0':'Outline'}
                      let flag = item.whetherOnline
                      item.whetherOnline = obj1.hasOwnProperty(flag)?this.$t('selectList.onlineType.'+obj1[flag]):flag


                      let obj2 = {'1':'Free','2':'Activate','3':'Return'}
                      let flag2 = item.status
                      item.status = obj2.hasOwnProperty(flag2)?this.$t('selectList.deviceStatus.'+obj2[flag2]):flag2



                       item.activateTime = item.activateTime? moment(item.activateTime*1).format('YYYY-MM-DD HH:mm:ss'):''
                       item.syncTime = item.syncTime?moment(item.syncTime*1).format('YYYY-MM-DD HH:mm:ss'):''
                       item.updateTime = item.updateTime?moment(item.updateTime*1).format('YYYY-MM-DD HH:mm:ss'):''

                        let hasSerialNumber = false
                        this.titleName.map(item=>{
                            if(item.key == 'serialNumber'){
                                hasSerialNumber = true
                            }
                        })
                        if(hasSerialNumber){
                            item.serialNumber = '= "'+(item.serialNumber.toUpperCase())+'"' // csv文件处理数值的数据时，默认数值型，要转成字符串，用：="字符串内容"。比如：'="+20"' 
                        }

                        return item
                    })
                });
                this.getData();
        },
        print(printpage){//打印
            var headstr = "<html><head><title></title></head><body>"; 
            var footstr = "</body>";
            var newstr = document.getElementById(printpage).innerHTML; 
            var OpenWindow = window.open("","_blank");
            OpenWindow.document.write(headstr+newstr+footstr);
            OpenWindow.print()
            return false; 

        },
        getSelect(){//获取下拉数据
            this.axios.post(this.config.urlArray.productsManageList, {dealerId:this.selectId,page:1,limit:10000}).then((result) => {
                let resData = result.data.data.productList
                this.productsManageList  = resData
            }).catch((err) => {
                // common.msg('error','获取失败',()=>{})
            });
 
        },
        getchartData(){//图表数据
            this.chartData.monthList = timerJs.getOldMonth();
            this.axios.post(this.config.urlArray.devicesChart, [...this.chartData.monthList]).then(result => {
		      common.ajaxMsg(result.data,false)
              this.chartData.dataList = result.data.data
              this.initEcharts()
		    }).catch(err => {
		    //   common.msg('error', err, () => {})
		    })

        },
        getTopData(){//汇总数据
     

            let myDate  = new Date();
           
			let myflag = myDate.getFullYear()+'-'+(myDate.getMonth()+1)+'-'+myDate.getDate()+" 00:00:00";    

            let myDate1  = new Date(myDate.getTime()-60*60*24*1000*31);
            let myflag2  = myDate1.getFullYear()+'-'+(myDate1.getMonth()+1)+'-'+myDate1.getDate()+" 00:00:00"; 

            let dataobj = {
				    params:{
                        dealerId:this.selectId,
				    	startDate:(new Date(myflag2)).getTime(),
				    	endDate:(new Date(myflag)).getTime()-1000
				    }
			    }
            this.axios.post(this.config.urlArray.devicesCount, dataobj.params).then(result => {
		    //   common.ajaxMsg(result.data)
              this.indexData.total = result.data.data.total
              this.indexData.signIn30 = result.data.data.someTimeActNum
              this.indexData.online = result.data.data.masterDeviceCount
		    }).catch(err => {
		    //   common.msg('error', err, () => {})
		    })
        

        },
        todelData(item) {// 解绑
            this.tableList.hasSelectData = item
            this.$refs.deleteChild.showit();
        },
        ievent() {// 解绑
            // console.log('解绑，下面注释掉了',this.tableList.hasSelectData)
            this.axios.post(this.config.urlArray.deviceUnbundling, {deviceId:this.tableList.hasSelectData.deviceId}).then((result)=>{
                common.ajaxMsg(result.data,true,()=>{
                    this.clearbtnStatus();
                    this.$refs.deleteChild.recancel();
                    this.getData();
                })
            }).catch((err)=>{
                // common.msg('error','删除失败')
            })
        },
        moveData() {  //移动数据
            this.addBox.showModel = true
            // this.addBox.editFormData = this.tableList.hasSelectData
            this.addBox.editFormDataArr = this.tableList.hasSelectDataArr
            this.addBox.callbackFn = () => {//回调处理
                //重新载入
                this.clearbtnStatus()
                this.addBox.showModel = false;
                this.getData();
            }
        },
        moveDealer(item) {  //移动经销商数据
            if(this.roleType==2) return
            this.moveDealerBox.showModel = true
            this.moveDealerBox.editFormData = item
            this.moveDealerBox.callbackFn = () => {//回调处理
                this.moveDealerBox.showModel = false;
                this.getData();
            }
        },
        addData(row){
            this.detailBox.showModel = true
            this.detailBox.editFormData = row
            this.detailBox.callbackFn = () => {//回调处理
                //重新载入
                this.clearbtnStatus()
                this.detailBox.showModel = false;
                // this.getData();
            }
        },

	    initEcharts(){
			 let myEchart = this.$echarts.init(document.getElementById("main"));
             let option = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    toolbox: {
                        feature: {
                            dataView: {show: false, readOnly: false},
                            magicType: {show: false, type: [ 'bar']},
                            restore: {show: false},
                            saveAsImage: {show: false}
                        }
                    },
					color:['#91CC75','#FAC244'], //关键加上这句话，legend的颜色和折线的自定义颜色就一致了
                    legend: {
                        data: ['个数', '个数']
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: this.chartData.monthList,
                            axisPointer: {
                                type: 'shadow'
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            // name: '水量',
                            // min: 0,
                            // max: 250,
                            // interval: 50,
                            axisLabel: {
                                formatter: '{value}'
                            }
                        },
                        {
                            type: 'value',
                            // name: '温度',
                            // min: 0,
                            // max: 25,
                            // interval: 5,
                            axisLabel: {
                                formatter: '{value}'
                            }
                        }
                    ],
                    series: [
                   
                        {
                            name: this.local=='en-US'?'Activate':'激活数',
                            type: 'bar',
                            data:  this.chartData.dataList,
							itemStyle: {
                                normal: {
                                  color: function (params) {
                                    //自定义颜色
                                    var colorList = ['#91CC75','#FAC244'];
                                    return colorList[0]
                                  }
                                }
                            }
                        },
                        // {
                        //     name: this.local=='en-US'?'Activate':'激活数',
                        //     type: 'line',
                        //     yAxisIndex: 1,
                        //     data: this.chartData.dataList,
						// 	itemStyle: {
                        //         normal: {
                        //           color: function (params) {
                        //             //自定义颜色
                        //             var colorList = ['#91CC75','#FAC244'];
                        //             return colorList[1]
                        //           },
                        //           lineStyle:{
                        //               color:'#FAC244'
                        //           }
                        //         }
                        //     }
                        // }
                    ]
             };
             myEchart.setOption(option);

		},

        setTitle(){
            this.titleName1.map((item)=>{
              item.title = item['title-'+this.local] || item.title
              return item
            })

            this.Operation.title = this.Operation['title-'+this.local] || '操作'
            
            let showField = []
            let localflag = this.local=='zh-CN'?'en-US':'zh-CN'
        
            if(this.selectedFieldList.length>0){
                for(let i=0;i<this.titleName1.length;i++){
                    for(let j=0;j<this.selectedFieldList.length;j++){
                        if((this.titleName1[i])['title-'+localflag]==this.selectedFieldList[j]){
                            // console.log('this.titleName1',(this.titleName1[i])['title-'+localflag])
                            showField.push(this.titleName1[i].title)
                        }
                    }
                }
                this.defaultCheckList = showField
            }
            
        },
        searchItem(){ //搜索
            this.loading = true
            this.getData()
        },
        getData() {//获取数据
            let getData = {
                params: {
                    page: this.page.current,
                    limit: this.page.pageSize,
                    sortfield: this.page.key,
                    ascDesc: this.page.order,
                    dealerId:this.selectId
                }
            }
           
            Object.assign(getData.params,this.searchObj)

            this.axios.post(this.config.urlArray.devicesList, getData.params).then((result) => {
                // common.ajaxMsg(result.data);
                let resData = result.data.data.deviceList
                //处理数组
                this.tableList.tableData  = resData
                this.page.total = result.data.data.meta.count
                this.loading = false
            }).catch((err) => {
                // common.msg('error','获取失败',()=>{})
            });
        },
        sortCustom(data) {//自定义排序
            this.page.key = data.key
            this.page.order = data.order
            this.getData()
        },
        
        selectChange(res) { //控制编辑和删除按钮的可用状态
            // console.log(res,'44')
            let productTypeIdArr = []
            let productTypeIdArr1 = null
            if(res.length>=1){
                res.map((item)=>{
                    productTypeIdArr.push(item.productTypeId) 
                })
                productTypeIdArr1 = new Set(productTypeIdArr)
            }
            
            if(productTypeIdArr1 && productTypeIdArr1.size==1){
                this.buttonList.editDisabled = this.buttonList.delDisabled = false
                this.tableList.hasSelectData = res[0]
                this.tableList.hasSelectDataArr = res
            }else{
                this.buttonList.editDisabled = this.buttonList.delDisabled = true
                this.tableList.hasSelectData = {}
                this.tableList.hasSelectDataArr = []
            }
        },

        changePage(nowpage) {//切换分页
            this.page.current = nowpage;
            this.getData();
        },
        changeSize(nowSize) {//切换每页显示条数
            this.page.pageSize = nowSize
            this.page.current = 1
            this.getData()
        },
        clearbtnStatus() { //删除后清空编辑数据 与按钮状态
            this.buttonList.delDisabled = true
            this.buttonList.editDisabled = true
            this.tableList.hasSelectData = {}
        }
    }
  }
</script>
 <style scoped lang="less">
 @media print {   
   .noprint {    
       display: none   
    }   
   /deep/ .ivu-table-header thead tr th{
       color: red;
        // &:nth-of-type(1){
        //     display: none;
        // }
     
    }
     /deep/ .ivu-table td{
        &:nth-of-type(1){
            display: none;
        }

    }
    .ivu-table-row td{
        &:nth-of-type(1){
            display: none;
        }
    }
} 

 /deep/ .ivu-table-fixed{
    height: 100%;
}
 /deep/ .ivu-table-fixed-right{
    height: 100%;
}
 /deep/ .ivu-table-fixed-body{
    height: 100% !important;
}
 .labelText{
     line-height: 54px;
     height: 54px;
     flex-shrink: 0;
     margin-right: 10px;
 }
 .echartsCon{
    background: #fff;
    margin: 40px 40px;
    border-radius: 14px;
    padding: 20px 40px;
     #main {
       // width: 100%;
   	   flex-grow:1;
       height:400px;
       margin: auto;
       margin-top: 30px
     }
     .titleCon{
       width: 350px;
       flex-shrink: 0;
       .titleConItem{
           border-bottom: 2px solid #EEF1F4;
           padding: 20px 18px 20px 35px;
           color: #3A464E;
           position: relative;
           &:nth-last-of-type(1){
               border-bottom:none
           }
           &::before{
               content: '';
               position: absolute;
               left: 12px;
               top:50%;
               transform: translateY(-50%);
               width: 6px;
               height: 26px;
               background: #4E77EF
           }
           &:nth-of-type(2){
                &::before{
                    background: #FFB139
                }
           }
           &:nth-of-type(3){
                &::before{
                    background: #3BC1DB
                }

           }

           .num{
               font-size: 20px;
               font-weight: bold;
           }
           .desc{
               height: 30px;
               line-height: 30px;
           }
           
       }
     }

 }

 .search-div{
     flex-wrap: wrap;
     background-color: #fff;
     padding: 34px 40px ;
     background: #FFFFFF;
     margin: 20px 40px;
     border-radius: 14px;
     .search-div-item{
         margin-right: 20px;
         span{
             margin-right: 30px;
         }
     }
     /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
         height:44px;
         line-height: 44px;
     }
     /deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
         height:44px;
         line-height: 44px;
     }
      /deep/ .ivu-select-single .ivu-select-selection{
        height: 44px;
        width: 200px;
     }
     /deep/  .ivu-input{
          height: 44px;
         line-height: 44px;
     }
     /deep/ .ivu-input-icon{
         height: 44px;
         line-height: 44px;
     }
     /deep/ .ivu-select-input{
         height: 44px;
         line-height: 44px;
     }
 }

 .tableCon{
     background-color: #fff;
     padding: 34px 40px 1px 34px;
     background: #FFFFFF;
     margin: 20px 40px;
     border-radius: 14px;
     .top{
         margin: 0 0 30px;
         .optionsIcon{
             margin-right: 15px;
         }
         .moveBotton{
             background: #3BC1DB;
             color: #fff;
             border-color: #3BC1DB;
             border-radius: 6px;
         }
     }
 }
  
.CheckboxSelect{
    position: absolute;
    left: 0;
    top:30px;
    width:150px;
    padding-bottom: 10px;
    background-color: #fff;
}
</style>
